import "../chunk-PKUHTIDK.js";
import { computedFormItemSize, computedCheckboxGroupSize } from "./index";
const api = ["state"];
const renderless = (props, { computed, reactive, watch }, { dispatch, constants }) => {
  const api2 = {
    computedFormItemSize: computedFormItemSize(props)
  };
  const formItemSize = computed(() => api2.computedFormItemSize());
  const state = reactive({
    checkboxGroupSize: computed(() => api2.computedCheckboxGroupSize())
  });
  Object.assign(api2, {
    state,
    computedCheckboxGroupSize: computedCheckboxGroupSize({
      props,
      formItemSize
    })
  });
  watch(
    () => props.modelValue,
    (value) => dispatch(constants.FORM_ITEM, constants.FORM_CHANGE, [value])
  );
  return api2;
};
export {
  api,
  renderless
};
